import React, { Component } from 'react';
import fire from '../../Firebase.js';
import SingleProud from './SingleProud/SingleProud';


class ShowPride extends Component {
    state = {
        prides: []
      }
    
      componentWillMount(){
        /* Create reference to messages in Firebase Database */
        let messagesRef = fire.database().ref('/pride/imProudOf').orderByKey();
        messagesRef.on('child_added', snapshot => {
          /* Update React state when message is added at Firebase Database */
          let pride = { content: snapshot.val().content, name: snapshot.val().name, key: snapshot.key, date: snapshot.val().date, instagram: snapshot.val().instagram};
          this.setState({ prides: [pride].concat(this.state.prides) });
          console.log(this.state.prides)
        })
      }
    
      render() {
        let prides = this.state.prides.map( proud => <SingleProud content={proud.content} date={proud.date} instagram={proud.instagram} key={proud.key} name={proud.name} instagram={proud.instagram}/> )
        return (
            this.state.prides ? <div><SingleProud main="yes" content="of finally accepting my own way of being different - and I am finally happy!" name="Dominik" instagram="dominikbrendan" />{prides}</div> : <div>Wait</div>
        );
      }
    }

export default ShowPride;


// WEBPACK FOOTER //
// ./src/MainContainer/ShowPride/ShowPride.js